<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>    
    <Migalha label="Gestão de acesso"></Migalha>
    
    <v-container>
      <v-layout row justify="center">
        <v-flex>
          <v-card class="pa-4 card-gestao-acesso">
            <!-- Seção Atualizar Senha -->
            <div class="p-t-none">
              <div class="tituloBox">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14 red--text" style="text-transform: none;">
                  Atualizar <strong style="text-transform: uppercase;">SENHA</strong>
                </h1>
              </div>
            </div>
            <div class="clear"></div>
            
            <v-form ref="formSenha" v-model="validSenha" lazy-validation>
              <v-layout row wrap>
                <!-- Campo Nova Senha -->
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="novaSenha"
                    :type="mostrarSenha ? 'text' : 'password'"
                    label="Nova Senha *"
                    :rules="senhaRules"
                    outlined
                    required
                    class="campo-senha"
                    validate-on-blur
                  ></v-text-field>
                </v-flex>
                
                <!-- Campo Confirmar Nova Senha -->
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="confirmarSenha"
                    :type="mostrarSenha ? 'text' : 'password'"
                    label="Confirmar Nova Senha *"
                    :rules="confirmarSenhaRules"
                    outlined
                    required
                    class="campo-senha"
                    validate-on-blur
                  ></v-text-field>
                </v-flex>
                
                <!-- Botões -->
                <v-flex xs12 class="botoes-container">
                  <v-btn 
                    color="success" 
                    block 
                    height="45"
                    class="white--text font-weight-bold mt-2 botao-senha"
                    @click="salvarSenha"
                    :disabled="!validSenha || !senhasIguais"
                  >
                    SALVAR SENHA
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
            
            <!-- Seção Atualizar E-mail -->
            <div class="p-t-none mt-5">
              <div class="tituloBox">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14 red--text" style="text-transform: none;">
                  Atualizar <strong style="text-transform: uppercase;">E-MAIL</strong>
                </h1>
              </div>
            </div>
            <div class="clear"></div>
            
            <v-form ref="formEmail" v-model="validEmail" lazy-validation>
              <v-layout row wrap>
                <!-- Campo Novo E-mail -->
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="novoEmail"
                    label="Novo E-mail *"
                    :rules="emailRules"
                    outlined
                    required
                    class="campo-email"
                    validate-on-blur
                  ></v-text-field>
                </v-flex>
                
                <!-- Campo Confirmar Novo E-mail -->
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="confirmarEmail"
                    label="Confirmar Novo E-mail *"
                    :rules="confirmarEmailRules"
                    outlined
                    required
                    class="campo-email"
                    validate-on-blur
                    @paste.prevent
                    autocomplete="off"
                  ></v-text-field>
                </v-flex>
                
                <!-- Botão Salvar E-mail -->
                <v-flex xs12 class="botoes-container">
                  <v-btn 
                    color="success" 
                    block 
                    height="45"
                    class="white--text font-weight-bold mt-2 botao-email"
                    @click="salvarEmail"
                    :disabled="!validEmail || !emailsIguais"
                  >
                    SALVAR E-MAIL
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    
    <!-- Pop-up Visualizar Senha Atual -->
    <v-dialog v-model="dialogSenhaAtual" max-width="300">
      <v-card>
        <v-card-title class="grey lighten-3">
          <span class="headline">Senha Atual</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <p>Sua senha é <strong>{{ senhaAtual }}</strong></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="info" 
            block
            @click="dialogSenhaAtual = false"
          >
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import loginService from "../../../services/loginService";
import Topo from "../../../components/Topo";
import Migalha from "../../../components/migalha";
import util from "../../../plugins/util";
import Vue from 'vue';

export default {
  name: "gestao-acesso",
  mixins: [util],
  components: {
    Migalha,
    Topo,
  },
  data() {
    return {
      showBox: true,
      validSenha: false,
      validEmail: false,
      novaSenha: '',
      confirmarSenha: '',
      novoEmail: '',
      confirmarEmail: '',
      mostrarSenha: false,
      dialogSenhaAtual: false,
      senhaAtual: 'caf123',
      senhaRules: [
        v => !!v || 'A senha é obrigatória',
        v => (v && v.length >= 6 && v.length <= 8) || 'A senha deve ter entre 6 e 8 caracteres',
        v => /^(?=.*[0-9])(?=.*[A-Za-z!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{6,8}$/.test(v) ||
          'A senha deve conter pelo menos uma letra ou caractere especial e números'
      ],
      confirmarSenhaRules: [
        v => !!v || 'A confirmação de senha é obrigatória',
        v => v === this.novaSenha || 'As senhas digitadas não coincidem.'
      ],
      emailRules: [
        v => !!v || 'O e-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'Email Inválido'
      ],
      confirmarEmailRules: [
        v => !!v || 'A confirmação de e-mail é obrigatória',
        v => v === this.novoEmail || 'Os e-mails digitados não coincidem.'
      ]
    };
  },
  computed: {
    senhasIguais() {
      return this.novaSenha === this.confirmarSenha;
    },
    emailsIguais() {
      return this.novoEmail === this.confirmarEmail;
    }
  },
  methods: {
    salvarSenha() {
      if (!this.$refs.formSenha.validate() || !this.senhasIguais) {
        if (!this.senhasIguais) {
          Vue.toasted.error("As senhas não conferem");
        }
        return;
      }
      
      // Modelo para fornecedor
      const modelFornecedor = {
        num_cgc_fornecedor: this.$store.getters.getUsuarioId,
        senha: this.novaSenha
      };

      // Modelo para usuário restrito
      const modelUsuario = {
        Id: this.$store.getters.getUsuarioId,
        Senha: this.novaSenha
      };
      
      const perfisPermitidos = ['cadastrador', 'validador', 'validadormaster', 'gestormaster'];
      const perfilUsuario = this.$store.getters.getPerfil;


      // Chamar serviço de alteração de senha
      if (perfisPermitidos.includes(perfilUsuario)) {
        // Usuário restrito: chama endpoint de usuário
        loginService.alterarSenhaUsuario(modelUsuario)
          .then(() => {
            Vue.toasted.success("Senha atualizada com sucesso!");
            this.limparFormularioSenha();
          })
          .catch((error) => {
            console.error("Erro:", error);
          });
      } else {
        // Fornecedor: chama endpoint de fornecedor
        loginService.alterarsenha(modelFornecedor)
          .then(() => {
            Vue.toasted.success("Senha atualizada com sucesso!");
            this.limparFormularioSenha();
          })
          .catch(() => {
            // Erro já tratado pelo interceptor do axios
          });
      }
    },
    
    salvarEmail() {
      if (!this.$refs.formEmail.validate() || !this.emailsIguais) {
        if (!this.emailsIguais) {
          Vue.toasted.error("Os e-mails não conferem");
        }
        return;
      }
      
      // Modelo para fornecedor
      const modelFornecedor = {
        num_cgc_fornecedor: this.$store.getters.getUsuarioId,
        email: this.novoEmail
      };
      // Modelo para usuário restrito
      const modelUsuario = {
        Id: this.$store.getters.getUsuarioId,
        Email: this.novoEmail
      };

      // Perfis que devem usar o endpoint de usuário restrito
        const perfisPermitidos = ['cadastrador', 'validador', 'validadormaster', 'gestormaster'];
        const perfilUsuario = this.$store.getters.getPerfil;
        
        if (perfisPermitidos.includes(perfilUsuario)) {
          // Usuário restrito: chama endpoint de usuário
          loginService.alterarEmailUsuario(modelUsuario)
            .then(() => {
              Vue.toasted.success("E-mail atualizado com sucesso!");
              this.limparFormularioEmail();
            })
            .catch((error) => {
              console.error("Erro:", error);
            });
        } else {
          // Fornecedor: chama endpoint de fornecedor
          loginService.alterarEmail(modelFornecedor)
            .then(() => {
              Vue.toasted.success("E-mail atualizado com sucesso!");
              this.limparFormularioEmail();
            })
            .catch((error) => {
              console.error("Erro:", error);
            });
        }
      },
    
    limparFormularioSenha() {
      this.novaSenha = '';
      this.confirmarSenha = '';
      this.mostrarSenha = false;
      this.$refs.formSenha.reset();
    },
    
    limparFormularioEmail() {
      this.novoEmail = '';
      this.confirmarEmail = '';
      this.$refs.formEmail.reset();
    },
  }
};
</script>

<style scoped>
.card-gestao-acesso {
  width: 1196px;
  max-height: 800px;  
  min-width: 140px;
  margin-left: -45px; 
  background: #fff;    /* Fundo branco */
}

.campo-senha, .campo-email {
  width: 680px;
  margin-bottom: 2px;
}

.botoes-container {
  max-width: 260px;
  margin: 0.5px;
  margin-left: 20px;
}

.botao-senha, .botao-email {
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 280px !important;
  max-width: 280px;
  min-height: 60px !important;
  max-height: 60px;
}

.red--text {
  color: black !important;
}

.v-btn.success {
  background-color: #4CAF50 !important;
}

.v-btn.info {
  background-color: #2196F3 !important;
}

.v-dialog .headline {
  font-size: 18px !important;
  font-weight: 500;
}

.v-card-actions .v-btn {
  background-color: #26C6DA !important;
  color: white !important;
  text-transform: uppercase;
  font-weight: 500;
}
</style>
